import Title from '../../Atoms/Title';
import Text from '../../Atoms/Text';
import CardText from '../../Molecules/CardText';
import Button from '../../Atoms/Button';

function BlockEmployer() {
  return (
    <div className="relative bg-sl-blue pb-32 pt-20">
      <div className="z-20 mx-auto w-full max-w-7xl px-7">
        <div className="mx-auto mb-7 w-full max-w-3xl text-center">
          <Title as="h2" color="white">
            <span>
              Synsel Techniek is dé werkgever voor technici
              in Nederland.
            </span>
          </Title>
        </div>
        <div className="mx-auto mb-20 w-full max-w-xl text-center">
          <Text color="white">
            Wij werken samen met de beste technische
            bedrijven en opdrachtgevers in de technische
            industrie zodat er rust en overzicht ontstaat.
          </Text>
        </div>
        <div className="grid items-stretch gap-7 md:grid-cols-3 lg:gap-14 lg:px-4">
          <CardText
            title="5420"
            text="Technische vacatures"
          />
          <CardText
            title="1825+"
            text="Geplaatste kandidaten"
          />
          <CardText
            title="632"
            text="Keuzes in werkgevers"
          />
        </div>
        <div className="mt-14 flex items-center justify-center">
          <Button text="Ontdek meer" color="accent" />
        </div>
      </div>
    </div>
  );
}

export default BlockEmployer;
